import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import FormVersionDetails from './FormVersionDetails';

const FormsVersionDetailsPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const formId = Number(id);
  const navigate = useNavigate();
  if (isNaN(formId)) {
    navigate('/404', { replace: true });
    return null;
  }

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:config_forms.table.header_form_versions')} />
      <FormVersionDetails formId={formId} />
    </ContentLayout>
  );
};

export default FormsVersionDetailsPage;
